import { JWT_KEY } from "Auth/Models/AuthConstants";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const SignInSsoProcessPage: React.FunctionComponent = (_) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const accessToken = searchParams.get("accessToken");
    if (!accessToken) {
      window.location.replace(AppRouting.ErrorSignIn.path());
      return;
    }

    localStorage.setItem(JWT_KEY, `Bearer ${accessToken}`);
    window.location.replace(AppRouting.Dashboard.path());
  }, [searchParams]);

  return null;
};
